import { widgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseWidgetKindArg = {
  widgetId: string;
};

export function useWidgetKind({ widgetId }: UseWidgetKindArg) {
  const widgetState = useSelectedFieldStore(
    widgetStore,
    () => widgetStore.get()[widgetId]?.widgetPayload.kind
  );
  return widgetState;
}
